import { render } from "./BackgroundColorEditor.vue?vue&type=template&id=6c36fa47"
import script from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundColorEditor.vue?vue&type=script&lang=js"

import "./BackgroundColorEditor.vue?vue&type=style&index=0&id=6c36fa47&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__